export default {
  mobileTiles: [
    {
      company: 'Inc',
      height: '192px',
      width: '240px',
      centered: true,
      naturalHeight: 122,
      naturalWidth: 152,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/2022_Inc_BestWorkplaces_Logo-desktop.png',
      customTileStyle: 'grow',
    },
    {
      company: 'Fortune Best Financial Services 2022',
      height: '122px',
      width: '151px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge131.png',
      customTileStyle: 'grow',
    },
    {
      company: 'Fortune Best Women',
      height: '122px',
      width: '80px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge128.png',
    },
    {
      company: "Fortune's Best Workplaces in the Bay Area 2023",
      height: '122px',
      width: '80px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge129.png',
    },
    {
      company: 'RealSimple Smart Money Awards 2023',
      height: '122px',
      width: '151px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge130.png',
    },
    {
      company: "Fortune's Best Workplaces for Millennials 2023",
      height: '122px',
      width: '60px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge132.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'MLT',
      height: '122px',
      width: '60px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge126.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fair Pay Workplace',
      height: '122px',
      width: '60px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge133.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Real Simple',
      height: '122px',
      width: '60px',
      centered: true,
      naturalHeight: 151,
      naturalWidth: 96,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge127.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Real Simple',
      height: '122px',
      width: '60px',
      centered: true,
      naturalHeight: 170,
      naturalWidth: 95,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge125.png',
      customTileStyle: 'press-logo-columns-6',
    },
  ],
  topTiles: [
    {
      company: 'Inc',
      height: '192px',
      width: '240px',
      centered: true,
      naturalHeight: 122,
      naturalWidth: 152,
      image:
        'https://www.nerdwallet.com/cdn/company/2023/awards/2022_Inc_BestWorkplaces_Logo-desktop.png',
      customTileStyle: 'press-logo-columns-5 wide',
    },
    {
      company: 'Fortune Best Financial Services 2022',
      height: '151px',
      width: '151px',
      naturalHeight: 151,
      naturalWidth: 96,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge131.png',
    },
    {
      company: 'Fortune Best Women',
      height: '151px',
      width: '151px',
      naturalHeight: 151,
      naturalWidth: 96,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge128.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: "Fortune's Best Workplaces in the Bay Area 2023",
      height: '151px',
      width: '151px',
      naturalHeight: 151,
      naturalWidth: 96,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge129.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'RealSimple Smart Money Awards 2023',
      height: '151px',
      width: '151px',
      naturalHeight: 151,
      naturalWidth: 96,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge130.png',
    },
  ],
  bottomTiles: [
    {
      company: "Fortune's Best Workplaces for Millennials 2023",
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge132.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'MLT',
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge126.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Fair Pay Workplace',
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge133.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Real Simple',
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge127.png',
      customTileStyle: 'press-logo-columns-6',
    },
    {
      company: 'Real Simple',
      height: '173px',
      width: '98px',
      naturalHeight: 170,
      naturalWidth: 95,
      image: ' https://www.nerdwallet.com/cdn/company/2023/awards/badge125.png',
      customTileStyle: 'press-logo-columns-6',
    },
  ],
};
